import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {GlOnClose, GoldenLayoutContainer} from 'ngx-golden-layout';
import GoldenLayout from 'golden-layout';
import {FieldsInterventionsPageRequest} from './fields-interventions-page-request';
import {
  MenuItem,
  FieldsInterventionsNavigationService
} from '../fields-interventions-navigation/fields-interventions-navigation.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-fields-interventions-page',
  templateUrl: './fields-interventions-page.component.html',
  styleUrls: ['./fields-interventions-page.component.scss']
})
export class FieldsInterventionsPageComponent implements OnInit, OnDestroy, AfterViewInit, GlOnClose {

  currentMenu: MenuItem;
  backgroundMenu: MenuItem;
  request: FieldsInterventionsPageRequest = new FieldsInterventionsPageRequest();

  width: number;
  height: number;
  private navigationSub: Subscription;

  constructor(
    @Inject(GoldenLayoutContainer) private container: GoldenLayout.Container,
    private transportNavigationService: FieldsInterventionsNavigationService,
  ) {
    this.currentMenu = transportNavigationService.current;
    this.backgroundMenu = transportNavigationService.backgroundMenu;
  }

  ngOnInit(): void {
    this.width = this.container.getElement().width();
    this.height = this.container.getElement().height() - 50;

    this.navigationSub = this.transportNavigationService.navigate$.subscribe(m => {
      this.currentMenu = m.current;
      this.backgroundMenu = m.background;
    });
  }

  ngOnDestroy(): void {
    this.navigationSub.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.request.submit();
  }

  glOnClose(): Promise<void> {
    this.transportNavigationService.navigateById(1);
    return Promise.resolve(undefined);
  }

}
